import * as TYPES from '../types'
import api from '../../api'

const state = {
  payment: {
    clothe: {
      ticket: {
        user: {
          profile: {}
        }
      }
    },
    fee: {

    }
  }
}

const mutations = {
  [TYPES.ON_GET_CLOTHE](state, data) {
    state.payment.clothe = data
  }
}

const actions = {
  [TYPES.DO_GET_CLOHTE]({commit}, id) {
    return new Promise((resolve, reject) => {
      api.DO_GET_CLOTHE(id)
      .then(res => {
        commit(TYPES.ON_GET_CLOTHE, res.data.data)
        resolve(res)
      })
      .catch(res => {
        reject(res)
      })
    })
  },
  [TYPES.DO_PAY_CLOTHE]({ commit }, payload) {
    return new Promise(function (resolve, reject) {
      api
        .DO_PAY_CLOTHE(payload.id, payload.fee)
        .then(res => {
          if (res.data.ok) {
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/clothe.js